<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="productForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="product" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                productForm: () => import('../forms/ProductForm'),
                product: () => import('../editViews/Product'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Blend', value: 'blendId', table: 'blends', form: () => import('../forms/BlendForm') },
                    { text: 'Bottled On', value: 'bottledOn', format: this.formatDate },
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Batch Number', value: 'batchNumber' },
                    { text: 'Client Name', value: 'clientName' },
                    { text: 'Product Grade', value: 'productGrade' },
                    { text: 'Bottle Size', value: 'bottleSize' },
                    { text: 'Number Of Bottles', value: 'numberOfBottles' },
                    { text: 'Dispatched On', value: 'dispatchedOn', format: this.formatDate },
                    { text: 'Is Compliant With Food Standards Code For Labelling', value: 'isCompliantWithFoodStandardsCodeForLabelling' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    blends: [],
                    facilities: [],
                    items: []
                },
                sorting: [
                    { column: "bottledOn", direction: "descending" },
                    { column: "name", direction: "ascending" },
                    { column: "blendId", direction: "ascending" },
                    { column: "facilityId", direction: "ascending" },
                ],
                itemsField: 'products',
                editPageName: 'product',
                apiMethod: 'Products',
                claimName: 'Products',
                formTitle: 'Product',
                excelTitle: 'Products',
                hasEditPage: true,
            }
        },
    };
</script>
